// executes provide callback while disabling propagation
// must be supplied to a mouse event
export default function withStopPropagation(cb: () => void) {
  return (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    cb();
  };
}
